module.exports = __webpack_public_path__ + "media/components/country-flag/static/nf-b3fdc60ada8d9644a42010d552b713db.svg";